import { Stack, Box, Chip, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import { BUILDING_TYPE_COLORS } from "@tracabois/components";

export interface MapFiltersProps {
  selectedTypes: string[];
  onTypesChange: (types: string[]) => void;
  departement: string;
  onDepartementChange: (dept: string) => void;
  buildingTypeItems: { id: string; name: string }[];
  nameById: Record<string, string>;
}

export const MapFilters = ({
  selectedTypes,
  onTypesChange,
  departement,
  onDepartementChange,
  buildingTypeItems,
  nameById,
}: MapFiltersProps) => {
  return (
    <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: "wrap", gap: 1 }}>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel>Type de bâtiment</InputLabel>
        <Select
          multiple
          value={selectedTypes}
          onChange={(e) => onTypesChange(e.target.value as string[])}
          label="Type de bâtiment"
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {(selected as string[]).map((id) => {
                const name = nameById[id] || id;
                return (
                  <Chip
                    key={id}
                    label={name}
                    size="small"
                    sx={{
                      backgroundColor: BUILDING_TYPE_COLORS[name] || "#999",
                      color: "white",
                    }}
                  />
                );
              })}
            </Box>
          )}
        >
          {buildingTypeItems.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: BUILDING_TYPE_COLORS[item.name] || "#999",
                  }}
                />
                {item.name}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Département"
        value={departement}
        onChange={(e) => onDepartementChange(e.target.value)}
        placeholder="Ex: 38, 73..."
        sx={{ width: 150 }}
      />
    </Stack>
  );
};
